.is-invalid > .react-select > div:first-child {
  border-color: var(--danger);
}

// cuadro de ingreso de datos
.__value-container {
  background-color: var(--form-input-bg);
  border-color: var(--form-input-border);

  &:focus {
    border-color: var(--primary);
    box-shadow: var(--primary);
  }

  &:hover {
    border-color: var(--form-input-border);
  }
}

.react-select {
  &.__menu {
    // refiere a la lista desplegable que tiene las opciones por elegir
    background-color: var(--form-input-bg);
  }

  &.__option--is-selected {
    // refiere a la opción que se encuentra elegida, pero ahora el foco se encuentra
    // mirando otra opcion, entonces se busca resaltar que la misma ha sido elegida
    background-color: var(--form-input-bg);
    color: var(--primary);
  }

  &.__control {
    // se utiliza el fondo como parte del borde, porque luego habra
    // elementos encima que componen el control
    background-color: var(--form-input-border);
    border-color: var(--form-input-border);

    &:hover {
      // para que cuando se pase por arriba no cambie el color
      // de bordes, porque asi funcionan los demás input
      border-color: var(--form-input-border);
    }
  }

  &.__indicator-separator {
    background-color: var(--form-input-border);
  }
}

.react-select .__indicator {
  background-color: var(--form-input-bg);
}

.react-select .__single-value {
  color: var(--form-input-color);
}

.react-select .__control--is-disabled > .__value-container {
  /*    color: var(--form-input-color); */
  background-color: var(--gray-300);
}

.react-select .__control--is-disabled > .__indicators > .__indicator {
  /*    color: var(--form-input-color); */
  background-color: var(--gray-300);
}

div.react-select__control--is-focused {
  border-color: var(--primary);
  box-shadow: var(--primary);

  &:hover {
    border-color: var(--primary);
    box-shadow: var(--primary);
  }
}

div.is-invalid {
  div.react-select.__control.react-select.__control--is-focused.react-select.__control--menu-is-open,
  div.react-select.__control.react-select.__control--is-focused {
    border-color: var(--danger);
    box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--danger) 25%, transparent);
  }
}

// cuando tiene el foco (menu abierto y sin abrir)
div.react-select.__control.react-select.__control--is-focused.react-select.__control--menu-is-open,
div.react-select.__control.react-select.__control--is-focused {
  border-color: var(--primary);
  box-shadow: var(--primary);
}

/* se trata de una de las opciones de la lista */
div.react-select.__option.react-select.__option--is-focused {
  background-color: var(--primary);
  color: hsla(0, 0%, calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)), 1);
}

div.react-select__option.react-select__option--is-selected {
  background-color: var(--gray-500);
  color: hsla(0, 0%, calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)), 1);
}

// menu con las opciones
div.react-select__menu {
  background-color: var(--form-input-bg);
}

div.react-select__indicator.react-select__dropdown-indicator {
  color: var(--form-input-border);
}

span.react-select__indicator-separator {
  background-color: var(--form-input-border);
}

div.react-select__single-value {
  color: var(--form-input-color);
}

/* bordes */

div.react-select.__control {
  border-radius: var(--bs-border-radius, 0.375rem);
}

div.react-select.__indicators {
  border-left: 1px solid var(--form-input-border);
}

div.react-select.__value-container {
  border-radius: var(--bs-border-radius, 0.375rem);
  padding: 2px 8px;
}

div.react-select.__indicator.react-select.__dropdown-indicator {
  border-radius: var(--bs-border-radius, 0.375rem);
  padding: 7px 8px;
}

div.react-select.__indicator.react-select.__clear-indicator {
  border-radius: var(--bs-border-radius, 0.375rem);
  padding: 7px 8px;
}
